import { render, staticRenderFns } from "./SelectWhatsAppTemplate.vue?vue&type=template&id=d28b01ba&scoped=true"
import script from "./SelectWhatsAppTemplate.vue?vue&type=script&lang=js"
export * from "./SelectWhatsAppTemplate.vue?vue&type=script&lang=js"
import style0 from "./SelectWhatsAppTemplate.vue?vue&type=style&index=0&id=d28b01ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28b01ba",
  null
  
)

export default component.exports